var exports = {
  "k": "x52a3aa3b--1b39af--container",
};

module.exports = exports;
